module.exports = __webpack_public_path__ + "img/logo-tpy.2e797f59.png";